import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import pluralize from '@sparefoot/react-core/utils/pluralize';

import { withOnVisibleFacilityHandler } from 'decorators/facility';

import { Text } from 'components/core/Typography';
import { Tooltip } from 'components/core/Tooltip';
import { Link } from 'components/core/Link';
import { Button } from 'components/core/Button';
import { FacilityImage } from 'components/facility/FacilityImage';
import { FacilityImageNotAvailable } from 'components/facility/ImageNotAvailable';
import { FacilityReviewSummary } from 'components/search/FacilityCard';
import { ViewportAction } from 'components/core/ViewportAction';

import { QuestionMark } from 'components/svg';

import './topYielderCard.scss';

export const enhance = withOnVisibleFacilityHandler;
export function TopYielderCard({ facility, onVisible, percentVisible }) {
	return (
		<ViewportAction
			onVisible={onVisible}
			percentVisible={percentVisible}
		>
			<div className="top-yielder-card">
				<div className="facility-image-container">
					<Link
						className="facility-image-link"
						href={facility.url.facility}
						hideBorder
						productClick
					>
						{facility.images.length ?
							<FacilityImage
								className="facility-image"
								src={facility.images.length > 1 ? facility.images[1] : facility.images[0]}
								alt={`${facility.name} - ${facility.location.streetAddress}`}
								size="medium"
								lazyLoad
							/> :
							<FacilityImageNotAvailable size="small" />
						}
					</Link>
					{facility.reviews.count > 0 &&
						<FacilityReviewSummary
							rating={facility.reviews.average}
							reviewCount={facility.reviews.count}
							facilityUrl={facility.url.facility}
							className="facility-review-mobile"
						/>
					}
				</div>
				<div className="details-and-button-container">
					<div className="facility-details-container">
						<Text size="tiny" color="yellow" className="tooltip-title">
							RECOMMENDED FACILITY
							<Tooltip
								className="top-yielder-tooltip"
								content={
									<Text size="tiny" weight="light" color="black" className="tooltip-text">
										Reserve here with confidence,
										this is one of our most trusted brands.
									</Text>
								}
							>
								<QuestionMark />
							</Tooltip>
						</Text>
						{facility.reviews.count > 0 &&
							<FacilityReviewSummary
								rating={facility.reviews.average}
								reviewCount={facility.reviews.count}
								facilityUrl={facility.url.facility}
								className="facility-review-desktop"
							/>
						}
						<Link
							href={facility.url.facility}
							hideBorder
							productClick
							className="facility-name"
						>
							<Text
								size="small"
								color="white"
								className="facility-title"
							>
								{facility.name}
							</Text>
						</Link>
						<Text
							size="tiny"
							weight="light"
							color="white"
							className="location"
						>
							{`${facility.location.city} ${facility.location.state} ${facility.location.zip}`}
						</Text>
						<Text
							size="tiny"
							weight="light"
							className="distance"
							color="white"
						>
							{`${facility.distance} ${pluralize('mile', facility.distance)} away`}
						</Text>
					</div>
					<div className="button-container">
						<Button
							href={facility.url.facility}
							productClick
							className="view-deals-button"
						>
							<Text size="small">
								View deals
							</Text>
						</Button>
					</div>
				</div>
			</div>
		</ViewportAction>
	);
}

TopYielderCard.propTypes = {
	facility: PropTypes.object,
	onVisible: PropTypes.func,
	percentVisible: PropTypes.number.isRequired
};

export default enhance(TopYielderCard);
